import renderMathInElement from '@/util/katex';

// regexes for testing content for unrendered math
const regexInline = /\\\(.*?\\\)/;
const regexBlock = /\\\[.*?\\\]/;
const regexExclude = [
  /<script[\s\S]*?<\/script>/gm,
  /title=".*?"/g,
  /data-answers-list=".*?"/g,
  /data-registered-choice=".*?"/g,
  /<textarea[\s\S]*?<\/textarea>/gm,

  // ex: <span>\(</span>x^2<span>\)</span>
  // used in formatting guide to prevent rendering
  /<span>\\(\(|\)|\[|\])<\/span>/g,
];

/**
 * Check text for unrendered math
 * @param {String} txt
 * @return {Boolean} true if txt contains math
 */
export function textContainsUnrenderedMath(txt) {
  let newTxt = txt;
  for (let i = 0; i < regexExclude.length; i += 1) {
    newTxt = newTxt.replace(regexExclude[i], '');
  }
  return regexInline.test(newTxt) || regexBlock.test(newTxt);
}

/**
 * Check element for unrendered math
 * @param {HTMLElement} element
 * @return {Boolean} true if element contains math
 */
function elementContainsUnrenderedMath(element) {
  return textContainsUnrenderedMath(element.innerHTML);
}

/**
 * If katex is not loaded, add element to rendering queue and trigger loading, if necessary.
 * Render element if katex is loaded
 * @param {HTMLElement} element
 */
function addToRenderQueue(element) {
  setTimeout(() => renderMathInElement(element));
}

/**
 * Preload katex when the user starts typing in a form input or textarea
 * @param {JQuery} $form
 */
export function formPreloader($form) {
  const $elements = $form.find('input[type=text], textarea');
  const evt = 'keydown.mjxpreload';
  $elements.on(evt, () => {
    $elements.off(evt);
  });
}

/**
 * Check if an element needs katex and load it if it does
 * @param {JQuery} $elements
 * @param {boolean} [forceRender]
 */
export function loadForElement($elements, forceRender = false) {
  if (typeof $elements.each === 'function') {
    $elements.each((index, el) => {
      if (forceRender || elementContainsUnrenderedMath(el)) {
        addToRenderQueue(el);
      }
    });
  } else {
    // support non-jQuery as well
    const elements = Array.isArray($elements) ? $elements : [$elements];
    elements.forEach(el => {
      if (forceRender || elementContainsUnrenderedMath(el)) {
        addToRenderQueue(el);
      }
    });
  }
}

/** Note that this handler is also used in the "content-team-visualizations" project */
export function onLoad(callback) {
  callback();
}

export function loadForElementAsync($elements, forceRender = false) {
  return new Promise(resolve => {
    loadForElement($elements, forceRender);
    resolve();
  });
}

/**
 * Load katex onload
 * Note that this controller is also used in the "content-team-visualizations" project
 */
export function controller() {
  const onload = () => addToRenderQueue(document.body);
  if (window.isLoaded) {
    onload();
  } else {
    window.addEventListener('load', onload);
  }
}
